import { Gondor } from "../Gondor";

const ACTIONS = {
  DEPOSIT: "/deposit/",
  DEPOSIT_ITEM: "/deposit/{id}/",
  ADD_SYSTEMS: "/deposit/add/system",
  REMOVE_SYSTEMS: "/deposit/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.DEPOSIT, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.DEPOSIT_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.DEPOSIT, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.DEPOSIT_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.DEPOSIT_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
